
import { Component } from '@angular/core';
import { SiteContextType } from '@spartacus/storefront';
import { SelectContextComponent } from '../select-context/select-context.component';

@Component({
  selector: 'currency',
  standalone: true,
  imports: [SelectContextComponent],
  templateUrl: './currency.component.html',
  styleUrl: './currency.component.scss',
})
export class CurrencyComponent {
  SiteContextType = SiteContextType;
}
